import { ChangeDetectionStrategy, Component, input, model } from '@angular/core';
import { ScFieldHover } from './field-hover.directive';

/**
 * Casilla del kit (reemplaza a dx-check-box): un checkbox nativo (oculto a la vista, con el texto
 * como nombre) y la caja con el ✓ que dibujaba DevExtreme. Sólo avisa los cambios de la persona.
 */
@Component({
  selector: 'sc-checkbox',
  changeDetection: ChangeDetectionStrategy.OnPush,
  hostDirectives: [ScFieldHover],
  host: {
    class: 'sck-checkbox',
    '[class.sck-checkbox--checked]': 'value()',
    '[class.sck-checkbox--disabled]': 'disabled()',
  },
  template: `
    <label class="sck-checkbox__label">
      <input
        class="sck-checkbox__native"
        type="checkbox"
        [checked]="value()"
        [disabled]="disabled()"
        (change)="value.set($any($event.target).checked)"
      />
      <span class="sck-checkbox__box" aria-hidden="true">
        @if (value()) {
          <span class="material-icons sck-icon" aria-hidden="true" data-icon="check"></span>
        }
      </span>
      @if (text()) {
        <span class="sck-checkbox__text">{{ text() }}</span>
      }
    </label>
  `,
})
export class ScCheckboxComponent {
  readonly value = model(false);
  readonly text = input('');
  readonly disabled = input(false);
}
